import React from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { H2 } from "./Styles";

function Partnerships() {
  const partners = [
    {
      src: require("../../../assets/images/fdcr.jpg"),
      alt: "FDCR",
      title: "Mediation Partner",
    },
    {
      src: require("../../../assets/images/npac.jpg"),
      alt: "NPAC",
      title: "Arbitration Partner",
    },
    {
      src: require("../../../assets/images/Empanelment-three.png"),
      alt: "IIAC",
      title: "Arbitration Partner",
    },
    {
      src: "https://justact-api-uploads.s3.ap-south-1.amazonaws.com/1/1766221576273-9bda9bc1-0ff8-4a33-a780-14892e36af53/iamc.png",
      alt: "IAMC",
      title: "Arbitration Partner",
    },
  ];

  return (
    <PartnersSection>
      <H2 style={{ textAlign: "center", marginBottom: "3rem" }}>
        Our Partners
      </H2>
      <PartnersContainer>
        <PartnersGrid>
          {partners.map((partner, index) => (
            <PartnerCard key={index}>
              <PartnerImage
                src={partner.src}
                alt={partner.alt}
                loading="lazy"
              />
              <PartnerLabel>{partner.title}</PartnerLabel>
            </PartnerCard>
          ))}
        </PartnersGrid>
      </PartnersContainer>
    </PartnersSection>
  );
}

export default Partnerships;

const PartnersSection = styled.section`
  width: 100%;
`;

const PartnersContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: clamp(1.5rem, 3vw, 2.5rem);

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const PartnerCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: clamp(1.25rem, 3vw, 2rem);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 129, 138, 0.15),
    0 4px 15px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 129, 138, 0.15);
  transition: all 0.3s ease;
  text-align: center;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0, 129, 138, 0.25),
      0 8px 25px rgba(0, 0, 0, 0.12);
    border-color: #00818a;
  }
`;

const PartnerImage = styled.img`
  width: 100%;
  height: 160px;
  object-fit: contain;
  border-radius: 12px;
  margin-bottom: 1rem;
  background: #fff;
  padding: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  ${PartnerCard}:hover & {
    transform: scale(1.05);
    box-shadow: 0 12px 30px rgba(0, 129, 138, 0.25);
  }
`;

const PartnerLabel = styled.div`
  font-family: ${theme.fonts.primaryFontBold};
  font-size: clamp(0.9rem, 2vw, 1.1rem);
  color: #00818a;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  line-height: 1.3;
`;
